import DashCard from "../../containers/dashcard";
import Othernav from "../../components/navs/othernav";
import FAQ from "../../components/user/faq";
import withAuth from "../../components/user/withAuth";

const Faq = () => {

  return (
    <div>
      <Othernav headerDetails="FAQ" navLink="/account/profile" />
      <DashCard className="max-w-4xl mx-auto p-4 md:mt-40">
        <FAQ/>
      </DashCard>
    </div>
  );
};

const FaqWithAuth = withAuth(Faq);
export default FaqWithAuth;
